import React, { useContext, useState } from 'react';
import {
  CButton,
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CModal,
  CModalBody,
} from '@coreui/react';
import { connect, DispatchProp } from 'react-redux';
import usePortal from 'react-useportal';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { UserInfo, UserRoles } from '../../shared/models/user';
import EditTechnicianModal from '../containers/modals/EditTechnicianModal';
import { ReInviteUser, RemoveUsers } from '../actions/userManagement.action';
import ResetPasswordModal from '../containers/modals/ResetPasswordModal';
import { ConfigContext } from '../../shared/contexts/journeyConfig.context';

export interface TechnicianActionsProps extends DispatchProp {
  technician: UserInfo;
}

const TechnicianActions = ({ technician, dispatch }: TechnicianActionsProps) => {
  const {
    enableOrgHierarchyModule
  } = useFlags();

  const [showEdit, setShowEdit] = useState(false);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const { Portal } = usePortal({
    bindTo: document && document.querySelector('body')
  });
  const toggle = ()=>{
    setDeleteConfirmModal(!deleteConfirmModal);
  }
  const labels = useContext(ConfigContext);

  const handleRemove = id => () => {
    dispatch(new RemoveUsers({
      ids: [id],
      includeChildren: enableOrgHierarchyModule
    }));
    setShowEdit(false);
  };

  const handleReInvite = id => () => {
    dispatch(new ReInviteUser(id));
  };

  const isAdmin = technician?.roles?.indexOf(UserRoles.Admin) > -1;

  return (
    <>
      <EditTechnicianModal technician={ technician } show={ showEdit } close={ () => setShowEdit(false) } />
      <ResetPasswordModal technician={ technician } show={ showResetPasswordModal } close={ () => setShowResetPasswordModal(false) } />
      <CDropdown>
        <CDropdownToggle
          caret
          size='xs'
          color='primary'
          className='bg-color-orange border-0'
        >
          Actions
        </CDropdownToggle>
        <Portal>
          <CDropdownMenu>
            <CDropdownItem id="technician-edit" onClick={ () => setShowEdit(true) }>
              Edit
            </CDropdownItem>
            <CDropdownItem id="technician-edit" onClick={ () => setShowResetPasswordModal(true) }>
              Reset Password
            </CDropdownItem>
            <CDropdownDivider />
            <CDropdownItem onClick={ handleReInvite(technician.id) }>
              Re-invite { labels.agent }
            </CDropdownItem>
            {
              !isAdmin ? (
                <>
                  <CDropdownDivider />
                  <CDropdownItem id="technician-remove" onClick={toggle}>
                    Remove
                  </CDropdownItem>
                </>
              ) : null
            }
          </CDropdownMenu>
        </Portal>
        <CModal
          className="mt-5 pt-5"
          show={deleteConfirmModal}
          onClose={toggle}
        >
          <CModalBody>
            <div className="flex-center text-block-md">You are about to remove {labels.agent} {technician.name}.</div>
            <div className="flex-center text-block-md mb-4">Are you sure?</div>
            <div className="flex-center m-3">
              <CButton
                color="danger"
                className="rounded-lg"
                onClick={ handleRemove(technician.id) }
              >Remove</CButton>
              <CButton
                color="secondary"
                className="rounded-lg"
                onClick={toggle}
              >Cancel</CButton>
            </div>
          </CModalBody>
        </CModal>
      </CDropdown>
    </>
  );
}

export default connect(null)(TechnicianActions);
